module.exports = __webpack_public_path__ + "files/0657834e74f5e69ac759b96fdcb172ef.png";